import { useEffect, useRef } from "react";

import useAxiosPrivate from "@/api/hooks/useAxiosPrivate";
import Table from "@/components/Table/Table";
import useResponse from "@/shared/hooks/useResponse";
import { useVehicleFilesTableStore } from "@/stores/useTableStore";

import LayoutWrapper from "../../../components/Layout/LayoutWrapper";
import VehicleFilesHeaderActions from "../../../components/PageHeader/actions/pageHeaderActions/VehicleFilesHeaderActions/VehicleFilesHeaderActions";
import TabFilters from "../../../components/TabFilters/TabFilters";
import useVehicleFilesInlineActions from "../../../components/Table/actions/inlineActions/hooks/useVehicleFilesInlineActions";
import { ROUTES, TABLE_NAMES } from "../../../shared";
import { FILES_PAGE_TABS } from "../config";

const VehicleFiles = () => {
  const { getData } = useAxiosPrivate();
  const { handleResponse } = useResponse();
  const { inlineActions } = useVehicleFilesInlineActions();

  const { fetchData, resetInitialLoading, setIsCheckable, setInlineActions } =
    useVehicleFilesTableStore();

  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      resetInitialLoading();
      hasFetched.current = true;
      handlePageLoad();
    }
  }, []);

  const handlePageLoad = async () => {
    await fetchData(getData, handleResponse);
    setIsCheckable(true);
    setInlineActions(inlineActions);
  };

  return (
    <>
      <LayoutWrapper
        showDetailsSection={false}
        infoIconTooltip={"Files##files header info tooltip"}
        route={ROUTES.VehicleFiles}
        tableName={TABLE_NAMES.Files}
      >
        <VehicleFilesHeaderActions />
      </LayoutWrapper>

      <Table
        hasDetails={false}
        tabFilters={<TabFilters tabs={FILES_PAGE_TABS} />}
        hasTabFilters
        route={ROUTES.VehicleFiles}
      />
    </>
  );
};

export default VehicleFiles;
